/* Detects the visitor's country (ISO-2) for phone-input defaults.
   Order: cookie cache -> IP lookup (cached in cookie for 30 days) -> browser locale. */

const COOKIE = "fr_country";

function readCookie(name: string): string {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

function writeCookie(name: string, value: string, days = 30) {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${days * 86400};SameSite=Lax`;
}

function fromLocale(): string {
  if (typeof navigator === "undefined") return "";
  const langs = [navigator.language, ...(navigator.languages || [])];
  for (const l of langs) {
    const m = (l || "").match(/-([A-Za-z]{2})$/);
    if (m) return m[1].toUpperCase();
  }
  return "";
}

/** Cached country code from cookie/locale, available synchronously. */
export function getCachedCountry(): string {
  const c = readCookie(COOKIE);
  return c ? c.toUpperCase() : "";
}

/** Resolves the visitor country, caching the result in a cookie. */
export async function detectCountry(): Promise<string> {
  const cached = getCachedCountry();
  if (cached) return cached;

  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 2500);
    const res = await fetch("https://ipapi.co/json/", { signal: ctrl.signal });
    clearTimeout(t);
    if (res.ok) {
      const data = await res.json();
      const code = String(data?.country_code || "").toUpperCase();
      if (/^[A-Z]{2}$/.test(code)) {
        writeCookie(COOKIE, code);
        return code;
      }
    }
  } catch {
    /* ignore — fall back to locale */
  }

  const loc = fromLocale();
  if (loc) writeCookie(COOKIE, loc, 1);
  return loc;
}
